// extracted by mini-css-extract-plugin
export var active = "_gv-7";
export var blink = "_gv-8";
export var dropDownSelector = "_gv-4";
export var dropDownWrapper = "_gv-3";
export var fakeCursor = "_gv-6";
export var fontSizeButton = "_gv-9";
export var formQuillEditor = "_gv-0";
export var pressed = "_gv-a";
export var qlBlank = "_gv-1";
export var textFormattingToolbar = "_gv-2";
export var textToolbarOption = "_gv-5";